define('controllers/mainmenu',['require','superfishmenu'],function(require) {
    require('superfishmenu');
});

